module.exports = __webpack_public_path__ + "static/together_img2@2x-270e8f58f2d9e7bf7b4996401686f909.png";